import { verify } from "@/lib/api/verify";

export const useUserStore = defineStore("userStore", () => {
    const tokenStore = useTokenStore();
    const { isLoggedIn, payload } = storeToRefs(tokenStore);
    const { setToken } = tokenStore;

    const { data, error } = useQuery({
        enabled: computed(() => isLoggedIn.value),
        queryFn: verify,
        queryKey: [
            "smake-use.masterApi.app.verify",
            computed(() => payload.value?.user_id),
        ],
        retry: false,
        select: (data) => data,
    });

    watchEffect(() => {
        if (!error.value) return;

        setToken();
    });

    const defaultLanguage = computed(() => {
        return data.value?.master.install_locale.code ?? "de";
    });

    return {
        data,
        error,
        defaultLanguage,
    };
});
